export const constant = {
	selector: {
		handler: 'data-m-copy-handler',
		target: 'data-m-copy',
		value: 'data-m-copy-value',
	},
}
